import {setupCrmDiff} from '../../common/crm-diff';
import {runOnce} from '../../common/run-once';
import {documentReady} from '../../document-ready';

runOnce('helper-crm-diff', () => {
    documentReady().then(() => {
        setupCrmDiff();
    });
});
